// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"196":"azure","997":"clipboard"}[chunkId] + "." + {"196":"34e7980c77f82b495e02","997":"299bae06e963a76751dd"}[chunkId] + ".js";
};